module.exports = __webpack_public_path__ + "static/media/Stadtgang01.4da1c9be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Stadtgang01.jpg
// module id = 352
// module chunks = 0